import React from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';
import { devices } from '@src/styles/theme';
type Props = {
  children: React.ReactNode;
  count?: number;
};

const LoadingSkeletonCard = () => {
  return (
    <CardContainer>
      <LoaderWrap>
        <div>
          <FlexColumn image={true}>
            <div>
              <Flex>
                <Skeleton
                  style={{
                    width: 34,
                    height: 34,
                    borderRadius: '50%',
                    marginRight: 10,
                  }}
                />
                <Skeleton style={{ width: 100, height: '100%' }} />
              </Flex>
            </div>
            <div>
              <Flex>
                <Skeleton style={{ width: 400, height: 200, marginTop: 10 }} />
                <div
                  style={{
                    marginLeft: 50,
                  }}
                >
                  <Skeleton
                    style={{ width: 243, height: 243, marginTop: 10 }}
                  />
                </div>
              </Flex>
            </div>
            <div>
              <Skeleton style={{ width: 400, height: '100%' }} />
            </div>
          </FlexColumn>
        </div>
      </LoaderWrap>
    </CardContainer>
  );
};

const Suspense = ({ children }: Props) => {
  return (
    <React.Suspense fallback={<LoadingSkeletonCard />}>
      {children}
    </React.Suspense>
  );
};

const defaults = {
  Suspense,
  LoadingSkeletonCard,
};

const CardContainer = styled.div`
  border-radius: 10px;
  background-color: ${({ theme }) => theme.commonColor.white};
  border: 1px solid ${({ theme }) => theme.commonColor.gray002};
  padding: 1rem 2rem;
  cursor: pointer;
  margin: 5px 0px;
  width: 100%;
`;

const LoaderWrap = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  @media ${devices.tablet} {
    display: block;
  }
`;

const FlexColumn = styled.div<{ image: boolean }>`
  height: 300px; //100% 더보기누를시
  max-height: 300px; //100% 더보기누를시
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: ${({ image }) => (image ? '20px' : 0)};
  width: 100%;
  @media ${devices.tablet} {
    margin-left: 0px;
    /* display: none; */
  }
`;

const Flex = styled.div`
  display: flex;
`;

export default defaults;
